<template>
  <div>
      <debtor-form />
  </div>
</template>

<script>
import {
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import DebtorForm from './DebtorForm.vue'

export default {
  components: {
    DebtorForm,
  },
  watch: {
    loader(val) {
      this.$store.commit('app/SET_GLOBAL_LOADING', { show: val, text: 'Opretter skyldner...' })
    },
  },
  beforeDestroy() {
    this.$store.commit('app/SET_GLOBAL_LOADING', false)
  },
  setup() {
    const loader = ref(false)
    return {
      loader,
      avatarText,
      BFormInvalidFeedback,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.spinner-border{
  width: 6rem;
  height: 6rem;
}
</style>
